module.exports = __webpack_public_path__ + "static/media/BirdSlider.aaa45056.webp";